import { Api } from '../api';
import { reports } from '../endpoints';
import type { FileResponse } from '../../models';
import type {
  GeneratePaymentReportRequest,
  GeneratePaymentAccountBalanceReportRequest,
  GenerateTransactionReportRequest,
  GenerateCardAccountBalanceReportRequest,
} from './models';

export class ReportApi extends Api {
  static generateTransactionReport = (request: GenerateTransactionReportRequest, signal?: AbortSignal) =>
    this.get<FileResponse>({ url: reports.generateTransactionReport(), queryParams: request, signal });

  static generateCardAccountBalanceReport = (request: GenerateCardAccountBalanceReportRequest, signal?: AbortSignal) =>
    this.get<FileResponse>({ url: reports.generateCardAccountBalanceReport(), queryParams: request, signal });

  static generatePaymentAccountBalanceReport = (request: GeneratePaymentAccountBalanceReportRequest, signal?: AbortSignal) =>
    this.get<FileResponse>({ url: reports.generatePaymentAccountBalanceReport(), queryParams: request, signal });

  static generatePaymentReport = (request: GeneratePaymentReportRequest, signal?: AbortSignal) =>
    this.get<FileResponse>({ url: reports.generatePaymentReport(), queryParams: request, signal });
}
